export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/a70fe28c30edbe909cade8425716fdee.svg";